/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blank_PageInputs */

const en_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blank Page`)
};

const es_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página en blanco`)
};

const fr_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page blanche`)
};

const de_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leere Seite`)
};

const ja_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白ページ`)
};

const zh_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白页`)
};

const ar_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صفحة فارغة`)
};

const id_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman Kosong`)
};

const it_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina vuota`)
};

const ru_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пустая страница`)
};

const pt_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página em branco`)
};

const ko_blank_page = /** @type {(inputs: Blank_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빈 페이지`)
};

/**
* | output |
* | --- |
* | "Blank Page" |
*
* @param {Blank_PageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const blank_page = /** @type {((inputs?: Blank_PageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blank_PageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blank_page(inputs)
	if (locale === "es") return es_blank_page(inputs)
	if (locale === "fr") return fr_blank_page(inputs)
	if (locale === "de") return de_blank_page(inputs)
	if (locale === "ja") return ja_blank_page(inputs)
	if (locale === "zh") return zh_blank_page(inputs)
	if (locale === "ar") return ar_blank_page(inputs)
	if (locale === "id") return id_blank_page(inputs)
	if (locale === "it") return it_blank_page(inputs)
	if (locale === "ru") return ru_blank_page(inputs)
	if (locale === "pt") return pt_blank_page(inputs)
	return ko_blank_page(inputs)
});